import * as React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  type Filters,
} from 'hooks/store/scheduled-restricted-products-data-imports/use-scheduled-data-imports-search-params';
import type {
  ScheduledProductRestrictionDataImportType as Type,
} from 'contracts/restricted-products/scheduled-data-imports';
import { Form, FormField } from 'components/ui/form';
import { ComboboxGs } from 'components/ui/Forms';
import { Button as ButtonGs } from 'components/ui/ButtonGs';

import { formSchema, type FormSchema } from './form-schema';
import { createFilterParams } from './utils';
import { getTypeName } from '../../utils';

type Props = {
  onSubmitFilters: (filters: Filters) => void
  onResetFilters: () => void
}

const types: Type[] = ['blocked-products', 'materials', 'sale-movements'];

const typeOptions: { value: Type, name: string }[] = types.map((type) => ({
  value: type,
  name: getTypeName(type),
}));

export const ScheduledImportsFilter = ({ onSubmitFilters, onResetFilters }: Props) => {
  const form = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
  });

  const resetForm = React.useCallback(() => {
    form.reset({
      type: undefined,
    }, { keepValues: false });
    onResetFilters();
  }, [form, onResetFilters]);

  const onFormSubmit = React.useCallback((formData: FormSchema) => {
    const filters = createFilterParams(formData);
    onSubmitFilters(filters);
  }, [onSubmitFilters]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onFormSubmit)} className={'w-full'}>
        <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'}>
          <FormField
            control={form.control}
            name={'type'}
            render={({ field }) => (
              <ComboboxGs
                label={'Tipo de importação'}
                form={form}
                fieldName={field.name}
                fieldValue={field.value}
                content={typeOptions}
                clearable
              />
            )}
          />
        </div>
        <div className={'flex gap-4 mt-6'}>
          <ButtonGs.Root
            type={'button'}
            variant={'secondary'}
            size={'sm'}
            onClick={resetForm}
          >
            Limpar filtros
          </ButtonGs.Root>
          <ButtonGs.Root type={'submit'} size={'sm'}>
            Filtrar
          </ButtonGs.Root>
        </div>
      </form>
    </Form>
  );
};
